import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Card } from '../components/ui/Card';
import { moodInsights } from '../data/insights';
import { Icon, moodGlyph } from '../components/icons/Icon';
import { useLocale } from '../contexts/LocaleContext';
import { useProgress } from '../contexts/ProgressContext';
export function MoodInsights() {
  const {
    t,
    tl
  } = useLocale();
  const progress = useProgress();
  return <div className="px-2 pb-2" data-id="element-2943" data-mp="r56z3lav1p4f">
      <PageHeader title={t('stats.insights.title')} subtitle={t('stats.insights.hint')} showBack data-id="element-2944" data-mp="r68eu32tmzsh" />

      <Card className="p-2" data-id="element-2945" data-mp="he2osyw4qsfx">
        <p className="bee-overline text-[9px] font-bold text-muted" data-id="element-2946" data-mp="hfdskypks071">
          {t('insights.todayMood')}
        </p>
        <p className="mt-1 flex items-center gap-1 text-[15px] font-bold text-deep" data-id="element-2947" data-mp="chc8qbkbrwui">
          {progress.mood ? <Icon name={moodGlyph[progress.mood]} size="md" tone="muted" data-id="element-2948" data-mp="8fqo241jue9r" /> : <span aria-hidden="true" data-id="element-2949" data-mp="3gxkp4fz83nb">—</span>}
          {progress.mood ? t(`mood.${progress.mood}`) : t('insights.noMood')}
        </p>
      </Card>

      <ul className="mt-2 space-y-2" data-id="element-2950" data-mp="rdnn3sn3ln7r">
        {moodInsights.slice(0, 3).map(insight => <li key={insight.id} className="rounded-card border border-sand-line bg-white/70 p-2" data-id="element-2951" data-mp="dm0gayvj4waq">
            <p className="text-[13.5px] font-medium leading-snug text-deep" data-id="element-2952" data-mp="hn2gbhx9tcdr">
              {tl(insight.text)}
            </p>
            <p className="mt-1 text-[11px] leading-snug text-muted" data-id="element-2953" data-mp="15ak99gs9ugib">
              {tl(insight.basis)}
            </p>
          </li>)}
      </ul>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-2954" data-mp="wax88w3gfcps">
        {t('insights.disclaimer')}
      </p>
    </div>;
}